import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconHomeOpen: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconHomeOpen"><Path d="M21 8.52441L12 1.21191L3 8.52441V21.0004L10 21V14H14V21L21 21.0004V8.52441Z" fill="currentColor"/></CentralIconBase>;
});

export default IconHomeOpen;
